import type { JSX } from "react";
import { messages } from "../messages";

interface LoginPageProps {
  onLogin: () => void;
  isBusy: boolean;
  error: string | null;
}

export function LoginPage({ onLogin, isBusy, error }: LoginPageProps): JSX.Element {
  return (
    <main className="page">
      <h1>{messages.appTitle}</h1>
      <p>{messages.loginBody}</p>
      {error !== null && <p role="alert">{error}</p>}
      <button type="button" onClick={onLogin} disabled={isBusy}>
        {isBusy ? messages.loginBusy : messages.loginButton}
      </button>
    </main>
  );
}
